import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import BackButton from "@Shared/components/general/back-button";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { mapActions } from "vuex";
import { DELETE_REFERRER } from "@Broker/js/modules/clients/referrers/store/referrer-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerDetailsHeader",
  components: {
    Fragment,
    BackButton,
    SimpleButton,
    InlinePrompt
  },
  props: {
    referrer: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: [String, Number],
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      preventDropdownClose: false,
      loading: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [DELETE_REFERRER])), {}, {
    async handleDeleteReferrer() {
      this.loading = true;
      try {
        await this.DELETE_REFERRER({
          referrerId: this.referrerId
        });
        this.navigateToRoot();
      } catch (e) {
        this.inlinePromptHide();
        this.$refs.actionsDropdown.hide(true);
      } finally {
        this.loading = false;
      }
    },
    navigateToRoot() {
      this.$router.push({
        name: "referrers"
      });
    },
    hideDropdown($event) {
      if (this.preventDropdownClose) $event.preventDefault();
    },
    inlinePromptHide() {
      this.preventDropdownClose = false;
    },
    inlinePromptShown() {
      this.preventDropdownClose = true;
    }
  })
});